export default function useRadarChartOptions () {
	return {
		responsive: true,
		// lineTension: 0.1,
		animation: false,
		borderJoinStyle: 'round',
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			r: {
				min: 0,
				max: 100,
				beginAtZero: true,
				ticks: {
					display: false,
					stepSize: 50,
					callback: (value, tick, values) => {
						if (value === 100) {
							return '100';
						}
						return value;
					}
				},
				pointLabels: {
					color: '#31527A',
					font: {
						size: 14
					}
				},
				grid: {
					color: ['#D6E0F1']
				},
				angleLines: {
					display: true,
					drawTicks: false,
					color: ['#F1F4FA']
				}
			}
		},
		elements: {
			line: {
				borderWidth: 2.5
			}
		},
		// ,maintainAspectRatio: true,
		// aspectRatio: 9 / 6,
		// plugins: {
		//   legend: {
		//     labels: {
		//       font: {
		//         size: 14
		//       }
		//     }
		//   },
		//   tooltip: {
		//     boxPadding: 12,
		//     padding: 12,
		//     footerMarginTop: 24,
		//     borderWidth: 2,
		//     callbacks: {
		//       footer: (tooltipItems) => {
		//         const selectedIndex = tooltipItems[0].dataIndex
		//         const description = tooltipItems[0].dataset.customTooltips[selectedIndex]
		//         return description
		//       }

		//     }
		//   }
		// },
		// layout: {
		//   padding: 20,
		//   autoPadding: true
		// },
		onResize: (chart, size) => {
			if (size.width < 420) {
				chart.options.scales.r.pointLabels.font.size = 9;
			} else if (size.width < 600) {
				chart.options.scales.r.pointLabels.font.size = 12;
			} else {
				chart.options.scales.r.pointLabels.font.size = 14;
			}
		}

	};
}
